import SectionLabel from './SectionLabel';
import originStory from '../../assets/images/about/about-origin-story.jpg';

const OriginStorySection = () => {
  return (
    <section className="relative overflow-hidden py-[64px] md:py-[100px] lg:py-[146px]">
      {/* Background image */}
      <img
        src={originStory}
        alt="Warm stage light over a crowd"
        className="absolute inset-0 w-full h-full object-cover object-[center_35%]"
      />
      {/* light black wash so the photo sits back behind the copy */}
      <div className="absolute inset-0 bg-black/65" />

      <div className="relative z-10 max-w-[1108px] mx-auto px-5 md:px-8 lg:px-0">
        <SectionLabel>ORIGIN STORY</SectionLabel>
        <h2 className="mt-[16px] md:mt-[22px] text-center text-white font-bold leading-[1.12] text-[28px] sm:text-[34px] md:text-[40px] lg:text-[54px]">
          It started with a struggle.
        </h2>

        <div className="mt-[28px] md:mt-[36px] lg:mt-[48px] max-w-[700px] mx-auto space-y-[18px] md:space-y-[24px]">
          <p className="text-white/75 text-[15px] md:text-[16px] lg:text-[18px] leading-[1.6]">
            Our founder, Sparsh Jain, was navigating the industry as a singer-songwriter and producer.
            He quickly realized how lonely and confusing this path can be. He saw artists full of talent
            but lost in the noise, unsure of how to record, how to market, or how to be heard.
          </p>
          <p className="text-white/75 text-[15px] md:text-[16px] lg:text-[18px] leading-[1.6]">
            He didn't want anyone else to feel that way. Artistto wasn't built as a business plan; it
            was built as a solution. It started to give artists the one thing they needed most: a team
            that cares as much about their music as they do.
          </p>
        </div>
      </div>
    </section>
  );
};

export default OriginStorySection;
